import { useTranslation } from "react-i18next";
import { useMe } from "../session/me";

export type NavItem = { to: string; label: string; description: string };

/** useNavItems lists the signed-in pages (the business portal for everyone); the admin entry only for platform administrators. */
export function useNavItems(): NavItem[] {
  const { t } = useTranslation();
  const me = useMe();
  const items: NavItem[] = [
    { to: "/consents", label: t("nav.consents"), description: t("hub.consents") },
    { to: "/approvals", label: t("nav.approvals"), description: t("hub.approvals") },
    { to: "/access-history", label: t("nav.access_history"), description: t("hub.access_history") },
    { to: "/receipts", label: t("nav.receipts"), description: t("hub.receipts") },
    { to: "/security", label: t("nav.security"), description: t("hub.security") },
    { to: "/business", label: t("nav.business"), description: t("hub.business") },
  ];
  if (me.data?.role === "platform_admin") {
    items.push({ to: "/admin", label: t("nav.admin"), description: t("hub.admin") });
  }
  return items;
}
